<template>
  <Modal
    v-model="_value"
    width="500"
    title="BSJ关闭驾驶员检测"
    @on-visible-change="visibleChange"
    ok-text="关闭"
    cancel-text="">
<!--    <Form ref="setDriverCardParamsRef" v-model="setDriverCardParams" :label-width="80">-->
      <Button type="primary" @click="onSendDriverCardParams">发送</Button>
<!--    </Form>-->
  </Modal>
</template>

<script>

import Vue from 'vue'
import { mapActions } from 'vuex'
import store from '@/store'
export default {

  name: 'bsjsetdriverdetectionmodal',
  components: {

  },
  props: {
    initValue: null,
    terminalNumValue: null,
    value: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      setDriverCardParams: {
        id: null,
        driverCardNum: null,
        driverLicenseNum: null,
        driverName: null
      },

      positioningDeviceType:false,
    }
  },
  methods: {
    ...mapActions([
    ]),
    visibleChange (val) {
      if (val) {
      }
    },
    onSendDriverCardParams () {
      let content = "<EXTD8012A0800000000>"
      store.dispatch('NetCommandServ_SendCommand', {
        params: { id: this._initValue, content: content, urgent: true }
      }).then(() => {
        this.$Message.success('发送成功')
      }).catch(err => {
        this.$Message.error(err)
      })
    }
  },
  computed: {
    _value: {
      get () {
        return this.value
      },
      set (val) {
        this.$emit('input', val)
        this.$emit('change', val)
      }
    },
    _initValue: {
      get () {
        return this.initValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    },
    _terminalNumValue: {
      get () {
        return this.terminalNumValue
      },
      set (val) {
        // this.$emit('input', val);
        // this.$emit('change', val);
      }
    }
  },
  mounted () {
    this.$nextTick(() => {

    })
  }
}
</script>
